
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class GlobalSettingsRepository {
  private static instance: GlobalSettingsRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): GlobalSettingsRepository {
    if (!GlobalSettingsRepository.instance) {
      GlobalSettingsRepository.instance = new GlobalSettingsRepository();
    }
    return GlobalSettingsRepository.instance;
  }

  public async getAllGlobalSettings(): Promise<any[]> {
    return (await api.get(API_ROUTES.GLOBAL_SETTINGS))?.data;
  }


  public async updateGlobalSettings(payload: any): Promise<any> {
    return (await api.put(API_ROUTES.GLOBAL_SETTINGS, payload))?.data;
  }

}
